import { clearFullStory } from '../third-parties';
import { isLocalEnvironment } from './environment.utils';

export const clearThirdParties = (): void => {
  if (!isLocalEnvironment()) {
    clearFullStory();
  }
};
